import kebabCase from "lodash.kebabcase"
import H2 from "components/atoms/H2"
import H4 from "components/atoms/H4"
import { TagList, Tag } from "components/atoms/Tags"
import VideoWithTitle from "components/molecules/VideoWithTitle"
import { handleScrollToAnchor } from "utils/browser"
import useTranslations from "hooks/useTranslations"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"

const Section = ({ sectionTitle, description, videos }) => {
  return (
    <div className="mb-12 text-zinc-800 lg:mb-8" id={kebabCase(sectionTitle)}>
      <H4>{sectionTitle}</H4>
      <p>{description}</p>
      <div className="grid-cols-2 gap-4 md:grid">
        {videos.map(({ title, link }) =>
          title && link ? (
            <VideoWithTitle
              title={title}
              link={link}
              key={`#${kebabCase(title)}/`}
            />
          ) : null,
        )}
      </div>
    </div>
  )
}

const OnboardingVideo = () => {
  const {
    videoPageTitle,
    otherSectionVideo1Title,
    otherSectionVideo1Description,
    videoSection1Video1Title,
    otherSectionVideo1Link,
    otherSectionVideo2Title,
    otherSectionVideo2Description,
    videoSection2Video1Title,
    otherSectionVideo2Link,
    videoSection3Title,
    videoSection3Description,
    videoSection3Video1Title,
    videoSection3Video1Link,
    videoSection3Video2Title,
    videoSection3Video2Link,
  } = useTranslations()

  const sections = [
    {
      sectionTitle: otherSectionVideo1Title,
      description: otherSectionVideo1Description,
      videos: [
        {
          title: videoSection1Video1Title,
          link: otherSectionVideo1Link,
        },
      ],
    },
    {
      sectionTitle: otherSectionVideo2Title,
      description: otherSectionVideo2Description,
      videos: [
        {
          title: videoSection2Video1Title,
          link: otherSectionVideo2Link,
        },
      ],
    },
    {
      sectionTitle: videoSection3Title,
      description: videoSection3Description,
      videos: [
        {
          title: videoSection3Video1Title,
          link: videoSection3Video1Link,
        },
        {
          title: videoSection3Video2Title,
          link: videoSection3Video2Link,
        },
      ],
    },
  ]

  return (
    <ContentPageContainer>
      <div className="">
        <div className="mb-4">
          <H2 textAlign="left">{videoPageTitle}</H2>
        </div>
        <TagList>
          {sections.map(({ sectionTitle }) => {
            const kebabSectionTitle = kebabCase(sectionTitle)
            return (
              <Tag
                to={`#${kebabSectionTitle}`}
                key={`${kebabSectionTitle}`}
                onClick={() => handleScrollToAnchor(`#${kebabSectionTitle}`)}
              >
                {sectionTitle}
              </Tag>
            )
          })}
        </TagList>
        {sections.map((section) => (
          <Section {...section} key={`#${kebabCase(section.sectionTitle)}/`} />
        ))}
      </div>
    </ContentPageContainer>
  )
}

export default OnboardingVideo
